module.exports = __webpack_public_path__ + "static/media/WhiteDove-PNG.208ad70b.png";